var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"command-help"}},[_c('span',{staticClass:"magneta"},[_vm._v(_vm._s(_vm.input))]),_vm._v(": invalid command\n")])}
var staticRenderFns = []

export { render, staticRenderFns }